/* GarnelenTv - Thermoverpackung

   Teil 1  Hinzufuegen: die passende Box faehrt im SELBEN /cart/add-Request mit.
   Teil 2  Abgleich:    nach JEDER Warenkorb-Aenderung wird der Sollzustand
                        hergestellt und die Warenkorbansicht neu aufgebaut,
                        ohne Seiten-Neuladen.

   Zwei Boxen, unabhaengig voneinander:
     Tier     -> Tierbox 4,99 EUR
     Pflanze  -> Pflanzenbox 2,99 EUR
     gemischt -> beide
   Je Sorte immer genau eine, unabhaengig von der Menge.

   Sollzustand kommt aus /cart?view=thermo (templates/cart.thermo.liquid).
   Das muss Liquid sein: cart.js liefert den Produkttyp, aber keine Tags,
   und die Regel lautet "Typ ODER Tag".

   Konfiguration und Regeln: snippets/thermo-config.liquid
*/
(function () {
  'use strict';

  var cfg = window.gtvThermo;
  if (!cfg || !cfg.boxes || !cfg.boxes.length) return;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var MARKER = 'X-GTV-Thermo'; // markiert eigene Anfragen, damit wir uns nicht selbst triggern
  var MAX_ADD_ATTEMPTS = 2;    // ponytail: simple Notbremse gegen Ping-Pong mit anderen Apps

  var boxIds = cfg.boxes.map(function (b) { return String(b.variantId); });
  var trigger = Object.create(null); // Varianten-ID -> Box-Key (fuer Teil 1)
  var inCart = Object.create(null);  // Box-Key -> liegt schon im Warenkorb
  var addAttempts = Object.create(null);

  function boxByKey(key) {
    for (var i = 0; i < cfg.boxes.length; i++) {
      if (cfg.boxes[i].key === key) return cfg.boxes[i];
    }
    return null;
  }

  function post(url, body) {
    var headers = { 'Content-Type': 'application/json', Accept: 'application/json' };
    headers[MARKER] = '1';
    return fetch(ROOT + url, {
      method: 'POST',
      headers: headers,
      credentials: 'same-origin',
      body: JSON.stringify(body)
    });
  }

  function get(url) {
    var headers = { Accept: '*/*' };
    headers[MARKER] = '1';
    return fetch(ROOT + url, { headers: headers, credentials: 'same-origin' });
  }

  /* ---------- Teil 1: Erkennung auf der Produktseite ---------- */

  function boxFor(product) {
    if (!product) return null;
    for (var i = 0; i < cfg.boxes.length; i++) {
      var b = cfg.boxes[i];
      if (b.types.indexOf(product.type) !== -1) return b;
      if (product.tags && product.tags.indexOf(b.tag) !== -1) return b;
    }
    return null;
  }

  function scanPage() {
    var nodes = document.querySelectorAll('[data-section-data]');
    for (var i = 0; i < nodes.length; i++) {
      var data;
      try { data = JSON.parse(nodes[i].textContent); } catch (e) { continue; }
      var p = data && data.product;
      if (!p || !p.variants) continue;
      var b = boxFor(p);
      if (!b) continue;
      for (var v = 0; v < p.variants.length; v++) {
        trigger[String(p.variants[v].id)] = b.key;
      }
    }
  }

  function readCart() {
    return get('cart.js').then(function (r) { return r.json(); });
  }

  function refreshCartState() {
    return readCart().then(function (cart) {
      cfg.boxes.forEach(function (b) {
        inCart[b.key] = cart.items.some(function (i) {
          return String(i.variant_id) === String(b.variantId);
        });
      });
      return cart;
    }).catch(function () { /* Zustand unveraendert lassen */ });
  }

  function parseForm(dataString) {
    var params = new URLSearchParams(dataString);
    var id = params.get('id');
    if (!id) return null;

    var item = { id: id, quantity: parseInt(params.get('quantity'), 10) || 1 };

    var props = null;
    params.forEach(function (value, key) {
      var m = /^properties\[(.+)\]$/.exec(key);
      if (m && value !== '') {
        props = props || {};
        props[m[1]] = value;
      }
    });
    if (props) item.properties = props;

    var plan = params.get('selling_plan');
    if (plan) item.selling_plan = plan;

    return item;
  }

  function boxToAdd(item) {
    if (!item) return null;
    var id = String(item.id);
    if (boxIds.indexOf(id) !== -1) return null;
    var key = trigger[id];
    if (!key || inCart[key]) return null;
    return boxByKey(key);
  }

  function payloadFor(item, box) {
    return { items: [item, { id: box.variantId, quantity: 1 }] };
  }

  function hookForms() {
    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form || form.tagName !== 'FORM') return;
      if ((form.getAttribute('action') || '').indexOf('/cart/add') === -1) return;

      var item;
      try {
        item = parseForm(new URLSearchParams(new FormData(form)).toString());
      } catch (e) { return; }

      var box = boxToAdd(item);
      if (!box) return; // normaler Ablauf, Formular geht raus wie bisher

      event.preventDefault();
      inCart[box.key] = true;

      post('cart/add.js', payloadFor(item, box)).then(function (r) {
        if (!r.ok) throw new Error('add failed');
        window.location.href = ROOT + 'cart';
      }).catch(function () {
        inCart[box.key] = false;
        form.submit(); // Fallback: nie den Kunden haengen lassen
      });
    }, true);
  }

  function hookJquery($) {
    // Nur relevant, falls der AJAX-Warenkorb (Drawer) je eingeschaltet wird.
    $.ajaxPrefilter(function (options) {
      if (!options.url || options.url.indexOf('/cart/add') === -1) return;
      if (typeof options.data !== 'string') return;
      if (options.contentType === 'application/json') return;

      var item = parseForm(options.data);
      var box = boxToAdd(item);
      if (!box) return;

      options.contentType = 'application/json';
      options.data = JSON.stringify(payloadFor(item, box));
      inCart[box.key] = true;
    });
  }

  /* ---------- Teil 2: Abgleich und Ansicht ---------- */

  function fetchState() {
    return get('cart?view=thermo')
      .then(function (r) { return r.text(); })
      .then(function (t) { return JSON.parse(t.trim()); });
  }

  var reconciling = false;

  // Bringt den Warenkorb in den Sollzustand. Liefert true, wenn etwas geaendert wurde.
  function reconcile() {
    if (reconciling) return Promise.resolve(false);
    reconciling = true;

    return fetchState().then(function (state) {
      var steps = [];

      cfg.boxes.forEach(function (b) {
        var s = state[b.key];
        if (!s) return;

        if (s.required && s.quantity === 0) {
          // Pflichtposition fehlt. Notbremse, falls eine andere App dagegenhaelt.
          addAttempts[b.key] = (addAttempts[b.key] || 0) + 1;
          if (addAttempts[b.key] > MAX_ADD_ATTEMPTS) return;
          steps.push(function () { return post('cart/add.js', { items: [{ id: b.variantId, quantity: 1 }] }); });
        } else if (s.required && s.quantity > 1) {
          steps.push(function () { return post('cart/change.js', { id: String(b.variantId), quantity: 1 }); });
        } else if (!s.required && s.quantity > 0) {
          steps.push(function () { return post('cart/change.js', { id: String(b.variantId), quantity: 0 }); });
        }
      });

      if (!steps.length) return false;
      return steps.reduce(function (chain, step) { return chain.then(step); }, Promise.resolve())
        .then(function () { return true; });
    }).catch(function () {
      return false;
    }).then(function (changed) {
      reconciling = false;
      return changed;
    });
  }

  function onCartPage() {
    return /\/cart\/?$/.test(window.location.pathname);
  }

  function cartSectionEl() {
    return document.querySelector('[id^="shopify-section-"][id$="__main"]');
  }

  // Stimmt die angezeigte Liste noch mit dem Server ueberein?
  // Nur fuer den Seitenaufruf gedacht: faengt Aenderungen ab, die eine
  // andere App gemacht hat, waehrend die Seite nicht offen war.
  function viewIsStale() {
    if (!onCartPage() || !cartSectionEl()) return Promise.resolve(false);
    return readCart()
      .then(function (cart) {
        return document.querySelectorAll('[data-line-item]').length !== cart.items.length;
      })
      .catch(function () { return false; });
  }

  // Baut die Warenkorbansicht neu auf, ohne Seiten-Neuladen.
  function refreshCartView() {
    if (!onCartPage()) return Promise.resolve();

    var el = cartSectionEl();
    if (!el) return Promise.resolve();
    var id = el.id.replace('shopify-section-', '');

    return get('cart?sections=' + encodeURIComponent(id))
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[id];
        if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html');

        var freshList = doc.querySelector('.cart__item-list');
        var currentList = document.querySelector('.cart__item-list');

        if (freshList && currentList) {
          // Nur den Inhalt tauschen, den Knoten behalten: an .cart__item-list
          // haengt der MutationObserver der Mindestbestellmengen-Logik.
          currentList.innerHTML = freshList.innerHTML;
        } else {
          var freshSection = doc.getElementById('shopify-section-' + id);
          el.innerHTML = freshSection ? freshSection.innerHTML : html;
        }

        // Leere und gefuellte Ansicht umschalten
        ['.cart__empty-cart-message', '.cart__form', '#cart_form'].forEach(function (sel) {
          var fresh = doc.querySelector(sel);
          var current = document.querySelector(sel);
          if (fresh && current) current.className = fresh.className;
        });

        // Theme seine eigenen Section-Skripte neu binden lassen
        el.dispatchEvent(new CustomEvent('shopify:section:load', {
          bubbles: true,
          detail: { sectionId: id }
        }));

        return readCart().then(function (cart) {
          var counters = document.querySelectorAll('[data-bind="itemCount"]');
          for (var i = 0; i < counters.length; i++) counters[i].textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  // Abgleichen und Ansicht nachziehen.
  // force = true nach jeder Warenkorb-Aenderung: dann kann sich auch nur ein
  // Betrag geaendert haben (Menge geaendert, Zeilenzahl gleich), und der
  // Warenwert oben wuerde sonst stehen bleiben.
  function syncNow(force) {
    return refreshCartState()
      .then(reconcile)
      .then(function (changed) {
        if (force || changed) return true;
        return viewIsStale();
      })
      .then(function (needsRefresh) {
        if (needsRefresh) return refreshCartView();
      });
  }

  var syncTimer = null;

  function scheduleSync() {
    if (syncTimer) clearTimeout(syncTimer);
    syncTimer = setTimeout(function () {
      syncTimer = null;
      syncNow(true);
    }, 350);
  }

  function isCartMutation(url) {
    return /\/cart\/(add|change|update|clear)/.test(String(url || ''));
  }

  // Jede Warenkorb-Aenderung anstossen, egal wer sie ausloest: Theme, Kunde
  // oder eine App. Eigene Anfragen sind ueber den Marker-Header ausgenommen.
  function watchCartRequests() {
    var origFetch = window.fetch;
    window.fetch = function (input, init) {
      var url = (typeof input === 'string') ? input : (input && input.url);
      var mine = !!(init && init.headers && (init.headers[MARKER] || init.headers[MARKER.toLowerCase()]));
      var result = origFetch.apply(this, arguments);
      if (isCartMutation(url) && !mine) {
        result.then(function () { scheduleSync(); }, function () {});
      }
      return result;
    };

    var origOpen = XMLHttpRequest.prototype.open;
    var origSend = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function (method, url) {
      this.__gtvUrl = url;
      return origOpen.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function () {
      if (isCartMutation(this.__gtvUrl)) this.addEventListener('loadend', scheduleSync);
      return origSend.apply(this, arguments);
    };
  }

  /* ---------- Start ---------- */

  scanPage();
  refreshCartState();
  hookForms();
  watchCartRequests();
  if (window.jQuery) hookJquery(window.jQuery);
  if (onCartPage()) syncNow(false);

  // Fuer Tests in der Browser-Konsole
  window.gtvThermoDebug = {
    parseForm: parseForm,
    boxFor: boxFor,
    boxToAdd: boxToAdd,
    trigger: trigger,
    inCart: inCart,
    addAttempts: addAttempts,
    fetchState: fetchState,
    reconcile: reconcile,
    viewIsStale: viewIsStale,
    refreshCartView: refreshCartView,
    syncNow: syncNow
  };
})();
